module.exports = __webpack_public_path__ + "img/square-ellipsis-vertical.608a2513.svg";